import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { qaaClick, qaaClose } from "../redux/actions";

export const Qaa = () => {
    const dispatch = useDispatch()
    const isMobile = useSelector(state => state.app.isMobile)
    const lang = useSelector(state => state.app.currentLang)
    const qaa = useSelector(state => state.app.qaa)
    const gameShopStatus = useSelector(state => state.game.gameShop.settings?.status)
    const isSupportEnabled = useSelector(state => state.user.isSupportEnabled)
    const showLink = useSelector(state => state.user.showLink)
    const link = useSelector(state => state.user.link)
    var k = 10;

    const hasLink = typeof link === 'string' && link.trim().length > 0;
    const href = !hasLink
        ? undefined
        : (/^https?:\/\//i.test(link) ? link : (process.env.REACT_APP_HOST + link));
    return (
        <div className="qaaList">
            {
                lang.qaa.map((item) => {
                    k++;
                    if (item.id === 5 && !(gameShopStatus === 'active')) return <></>;
                    return (
                        <div className={'qaaList__item ' + (qaa === item.id ? 'active' : '')} key={item.id}
                            onClick={() => qaa !== item.id ? dispatch(qaaClick(item.id)) : dispatch(qaaClose())}>
                            <div className="qaaList__item_q">{item.q}</div>
                            <div className="qaaList__item_a" dangerouslySetInnerHTML={{ __html: item.a }} />
                        </div>
                    )
                }
                )
            }
            {
                isMobile && isSupportEnabled === 1 && (
                    <div className={'qaaList__item ' + (qaa === k ? 'active' : '')}
                        onClick={() => qaa !== k ? dispatch(qaaClick(k)) : dispatch(qaaClose())}>
                        <div className="qaaList__item_q">{lang.message6}</div>
                        <div className="qaaList__item_a"
                            dangerouslySetInnerHTML={{ __html: '<p>' + lang.message3 + '</p>' }} />
                    </div>
                )
            }
            {
                isMobile && showLink === 1 && hasLink && (
                    <a href={href} target="_blank" rel="noreferrer"
                        className="mobilePopup__btn">
                        {lang.menu4}
                    </a>
                )
            }
        </div>
    )
}